import * as React from "react";
import {useEffect} from "react";
import {backend} from "../../../../../xconvert-backend";
import {Button, Icon, Table} from "semantic-ui-react";
import {DatabaseVersion, MigrationTask} from "../../../../../generated";
import {authentication} from "../../../../../authentication";
import "react-datepicker/dist/react-datepicker.css";

interface MigrationsWithDate {
    migration: MigrationTask
    dbVersion: DatabaseVersion
}
export function Migrations() {

    const [migrations, setMigrations] = React.useState<MigrationsWithDate[]>([]);
    const [currentDBVersion, setCurrentDBVersion] = React.useState(-1);
    const [loading, setLoading] = React.useState(true);

    useEffect(() => {
        fetchMigrations();
    }, []);

    function fetchMigrations() {
        setLoading(true);
        const auth = backend.withTokenAuthHeader(authentication.token)

        backend.internalApi.fetchMigrations(auth).then((response) => {
            // console.log("fetchMigrations", response)
            const migration = response.migrations
            const dbVersions = response.dbVersions
            const migrationsWithDate = migration.map(mig => {
                const dbVersion = dbVersions.find(dbv => dbv.currentVersion === mig.preMigrationDbVersion + 1)
                return {
                    migration: mig,
                    dbVersion: dbVersion
                }
            })


            setMigrations(migrationsWithDate)
            setCurrentDBVersion(response.currentDbVersion)
        }).finally(() => {
            setLoading(false);
        })
    }

    function onMigrateClicked() {
        setLoading(true);
        const auth = backend.withTokenAuthHeader(authentication.token)
        backend.internalApi.migrateDb(false, auth).then((response) => {
            // console.log("migrateDb", response)
            fetchMigrations();
        }).finally(() => {
            setLoading(false);
        })
    }

    if (loading) {
        return (
            <div style={{padding: 10}}>
                <span>Loading migrations...</span>
            </div>
        );
    }
    const hasPendingMigrations = migrations.some(m => m.migration.preMigrationDbVersion >= currentDBVersion);

    return <div
        style={{
            padding: 10,
        }}>
        {hasPendingMigrations &&
            <Button
                floated={"right"}
                onClick={() => onMigrateClicked()}
                color={"orange"}
                disabled={!hasPendingMigrations}
            >
                <Icon name={"cogs"}/>
                Run migrations
            </Button>
        }
        Current DB Version: {currentDBVersion} <br/>
        Total: {migrations.length ?? 0}
        <Table celled>
            <Table.Header>
                <Table.HeaderCell>DB Version</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>
                <Table.HeaderCell>Pre-Migration DB Version</Table.HeaderCell>
                <Table.HeaderCell>Date</Table.HeaderCell>
            </Table.Header>
            {[...migrations]
                .sort((a, b) => (b.migration.preMigrationDbVersion) - (a.migration.preMigrationDbVersion))
                .map((migration, index) => {
                    return (
                        <Table.Row key={index}>
                            <Table.Cell>{migration.migration.preMigrationDbVersion + 1}</Table.Cell>
                            <Table.Cell>{migration.migration.description}</Table.Cell>
                            <Table.Cell>{migration.migration.preMigrationDbVersion}</Table.Cell>
                            <Table.Cell>{migration.dbVersion?.migrationDate}</Table.Cell>
                        </Table.Row>
                    )
                })}
        </Table>

    </div>
}